import { getApiBaseUrl as getApiBaseUrlFromEnv, resolveEnvironment } from '@seede/api-client';

export const getApiBaseUrl = (): string => {
  return getApiBaseUrlFromEnv(resolveEnvironment());
};

export const useApi = () => {
  const { getToken } = useAuth();

  const request = async (
    url: string,
    options: {
      method?: string;
      headers?: Record<string, string>;
      body?: any;
      query?: Record<string, any>;
    } = {}
  ) => {
    const token = getToken();
    if (!token) {
      throw new Error('No authentication token');
    }

    const apiBase = getApiBaseUrl();
    let requestUrl = url.startsWith('http') ? url : `${apiBase}${url}`;

    // Add query parameters
    if (options.query) {
      const queryString = new URLSearchParams(
        Object.entries(options.query).reduce(
          (acc, [key, value]) => {
            if (value !== undefined && value !== null) {
              acc[key] = String(value);
            }
            return acc;
          },
          {} as Record<string, string>
        )
      ).toString();
      requestUrl += `?${queryString}`;
    }

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    };

    const response = await $fetch(requestUrl, {
      method: (options.method || 'GET') as any,
      headers,
      body: options.body ? JSON.stringify(options.body) : undefined,
    });

    return response;
  };

  return {
    api: getApiBaseUrl(),
    request,
  };
};
